import type { ChequesTerceroFiltrosStored } from './types';

export type ChequesTerceroQueryParams = Record<string, string | number | boolean>;

export function buildChequesTerceroParams(input: {
  pageNumber: number;
  pageSize: number;
  searchTerm: string;
  nroBanco: string;
  nroSucursal: string;
  fechaIngresoDesde: string;
  fechaIngresoHasta: string;
  fechaSalidaDesde: string;
  fechaSalidaHasta: string;
  fechaVencimientoDesde: string;
  fechaVencimientoHasta: string;
  importeDesde: string;
  importeHasta: string;
  mcp: string;
  estado: string;
  nroCliente: number | null;
  nroProveedor: number | null;
  nroBancoDeposito: string;
  nroCuentaDeposito: string;
  filtroTipoSoporte?: string;
}): ChequesTerceroQueryParams {
  const params: ChequesTerceroQueryParams = {
    pageNumber: input.pageNumber,
    pageSize: input.pageSize,
  };

  if (input.searchTerm.trim()) params.searchTerm = input.searchTerm.trim();
  if (input.nroBanco) params.nroBanco = parseInt(input.nroBanco, 10);
  if (input.nroSucursal) params.nroSucursal = parseInt(input.nroSucursal, 10);
  if (input.fechaIngresoDesde) params.fechaDesde = input.fechaIngresoDesde;
  if (input.fechaIngresoHasta) params.fechaHasta = input.fechaIngresoHasta;
  if (input.fechaSalidaDesde) params.fechaSalidaDesde = input.fechaSalidaDesde;
  if (input.fechaSalidaHasta) params.fechaSalidaHasta = input.fechaSalidaHasta;
  if (input.fechaVencimientoDesde) params.fechaVencimientoDesde = input.fechaVencimientoDesde;
  if (input.fechaVencimientoHasta) params.fechaVencimientoHasta = input.fechaVencimientoHasta;
  if (input.importeDesde && !Number.isNaN(parseFloat(input.importeDesde))) {
    params.importeDesde = parseFloat(input.importeDesde);
  }
  if (input.importeHasta && !Number.isNaN(parseFloat(input.importeHasta))) {
    params.importeHasta = parseFloat(input.importeHasta);
  }
  if (input.mcp.trim()) params.mcp = input.mcp.trim();
  if (input.estado.trim()) params.estado = input.estado.trim();
  if (input.nroCliente != null && input.nroCliente > 0) params.nroCliente = input.nroCliente;
  if (input.nroProveedor != null && input.nroProveedor > 0) params.nroProveedor = input.nroProveedor;
  if (input.nroBancoDeposito) params.nroBancoDeposito = parseInt(input.nroBancoDeposito, 10);
  if (input.nroCuentaDeposito && !Number.isNaN(parseInt(input.nroCuentaDeposito, 10))) {
    params.nroCuentaDeposito = parseInt(input.nroCuentaDeposito, 10);
  }
  if (input.filtroTipoSoporte === 'fisicos') {
    params.esElectronico = false;
  } else if (input.filtroTipoSoporte === 'electronico') {
    params.esElectronico = true;
  }

  return params;
}

export function mapResumenFromApi(data: unknown): {
  totalCount: number;
  totalImporte: number;
  enCarteraCount: number;
  vencenEsteMesCount: number;
} | null {
  const r = (data as { resumen?: Record<string, unknown> })?.resumen;
  if (!r) return null;
  return {
    totalCount: Number(r.totalCount ?? r.TotalCount ?? 0),
    totalImporte: Number(r.totalImporte ?? r.TotalImporte ?? 0),
    enCarteraCount: Number(r.enCarteraCount ?? r.EnCarteraCount ?? 0),
    vencenEsteMesCount: Number(r.vencenEsteMesCount ?? r.VencenEsteMesCount ?? 0),
  };
}

export type FiltrosPersistidos = ChequesTerceroFiltrosStored;
